export default __webpack_public_path__ + "static/media/gmail_logo.7e771195.svg";